import { DEFAULT_LANGUAGE } from '@procureai/schemas';
import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

export const procurementKnowledgeDocumentSchema = z.object({
  fileId: z.string(),
  title: z.string().min(1),
  description: z.string().min(1),
  url: z.string().optional(),
  variant: z.string(),
  language: z.string().transform((value) => value.toUpperCase()),
  content: z.string().nullish(),
});
export type ProcurementKnowledgeDocumentData = z.infer<typeof procurementKnowledgeDocumentSchema>;

export const procurementKnowledgeDocumentDataDefault: (
  data?: DefaultValues<ProcurementKnowledgeDocumentData>,
) => DefaultValues<ProcurementKnowledgeDocumentData> = (data) => ({
  title: '',
  description: '',
  variant: '',
  url: '',
  language: DEFAULT_LANGUAGE,
  ...data,
});
